import { useState } from 'react'
import './ClarificationCard.css'

/**
 * ClarificationCard - Asks the user a question with selectable options.
 *
 * Props:
 *   stepLabel: string - e.g. "Step 3 · Tax Jurisdiction Comparison"
 *   question: string | ReactNode
 *   options: array of { label, description }
 *   defaultSelected: number (index), or null so the user must choose
 *   onSubmit: function(selectedIndex, remember)
 *   submitLabel: the button's text
 *   rememberLabel: the checkbox's text (a company scope is remembered per person)
 */
export default function ClarificationCard({
  stepLabel,
  question,
  options = [],
  defaultSelected = null,
  onSubmit,
  submitLabel = 'Continue Investigation →',
  rememberLabel = 'Remember for this customer',
}) {
  const [selected, setSelected] = useState(defaultSelected)
  const [remember, setRemember] = useState(true)

  return (
    <div className="clarification-card">
      <div className="clarification-header">
        <div className="clarification-icon">?</div>
        <div>
          <div className="clarification-title">I need clarification to continue</div>
          <div className="clarification-subtitle">{stepLabel}</div>
        </div>
      </div>
      <div className="clarification-body">
        <div className="clarification-question">{question}</div>
        <div className="clarification-options">
          {options.map((opt, i) => (
            <div
              key={i}
              className={`clarification-option ${selected === i ? 'selected' : ''}`}
              onClick={() => setSelected(i)}
            >
              <div className="option-radio">
                <div className="option-radio-dot" />
              </div>
              <div className="option-text">
                <div className="option-label">{opt.label}</div>
                {opt.description && <div className="option-desc">{opt.description}</div>}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="clarification-footer">
        <label className="remember-check">
          <input
            type="checkbox"
            checked={remember}
            onChange={(e) => setRemember(e.target.checked)}
          />
          {rememberLabel}
        </label>
        <button
          className="submit-clarification"
          disabled={selected === null || selected === undefined}
          onClick={() => onSubmit?.(selected, remember)}
        >
          {submitLabel}
        </button>
      </div>
    </div>
  )
}
